
import Vue from "vue";
import vuetifyToast from "vuetify-toast";
import { Component, Watch, Prop } from "vue-property-decorator";
import { DateHelper } from "@/util/DateHelper";
import Booking from "./Booking/models/Booking";
import IAddressViewModel, {
  AddressTypeEnum
} from "./Booking/models/IAddressViewModel";
import Destination from "./Passenger/models/Destination";
import IGooglePlaceAddressComponents from './Booking/models/IGooglePlaceAddressComponents';
import IGooglePlaceCachedPrediction from './Booking/models/IGooglePlaceCachedPrediction';
import IBookingAddressViewModel from './Booking/models/IBookingAddressViewModel';

@Component({
  components: {}
})
export default class PlacePicker extends Vue {
  
  @Prop({ required: true })
  booking: Booking;

  @Prop({ required: true })
  modelProperty: string;

  @Prop({ required: true })
  allowedPlacesInfo: IBookingAddressViewModel;

  @Prop({ default: "" })
  placeholder: string;

  @Prop({ default: false })
  disabled: boolean;

  @Prop({ default: false })
  clearable: boolean;

  @Prop({ default: false })
  isOrigin: boolean;

  isLoading: boolean = false;

  items: IGooglePlaceCachedPrediction[] = [];
  search: string = "";
  autocompleteSessionToken: google.maps.places.AutocompleteSessionToken;

  model: IGooglePlaceCachedPrediction = null;

  placeSelectedFlag: boolean = false;
  countryRestriction: string = this.getCountryRestriction() ?? "fi";

  get formattedAddress(){
    // Disabled, return null
    return null;
    // if (this.isOrigin) {       
    //   return this.booking.fromAddress;
    // } else {
    //   return this.booking.toAddress;
    // }
  }

  // filter(item: IGooglePlaceCachedPrediction, queryText, itemText) {
  //     const alias = item.alias;
  //     if (alias){

  //     }
  //     const itemName = item.name.toLowerCase()
  //     const searchText = queryText.toLowerCase()
  //     return itemName.indexOf(searchText) > -1;
  // }

  onClear() {
    if (this.isOrigin) {
      this.booking.fromPlace = null;
      this.booking.fromAddress = null;
    } else {
      this.booking.toPlace = null;
      this.booking.toAddress = null;
    }
  }

  get filteredItems(){
    // console.log("fetching filtered items");
    if (!this.search){
      // console.log("not searching - returning items list");
      return this.items;
    }
    const query = this.search.toLowerCase();
    return this.items
      .filter(i =>  
        i.prediction.description.toLowerCase().includes(query) || 
        (
          i.alias && 
          i.alias.toLowerCase().includes(query)
        )
      )      
      .sort((a, b) => {
        let scoreA = 0;
        let scoreB = 0;

        if (a.alias){
          const aliasA = a.alias.toLowerCase();
          if (aliasA === query){
            scoreA += 1000000000;
          } else if (aliasA.startsWith(query)){
            scoreA += 1000000
          } 
        }

        if (b.alias){
          const aliasB = b.alias.toLowerCase();
          if (aliasB === query){
            scoreB += 1000000000;
          } else if (aliasB.startsWith(query)){
            scoreB += 1000000
          } 
        } 

        const descA = a.prediction.description.toLowerCase();
        if (descA === query){
          scoreA += 1000000;
        } else if (descA.startsWith(query)){
          scoreA += 1000;
        } else if (descA.includes(query)){
          scoreA += 1;
        } 

        const descB = b.prediction.description.toLowerCase();
        if (descB === query){
          scoreB += 1000000;
        } else if (descB.startsWith(query)){
          scoreB += 1000
        } else if (descB.includes(query)){
          scoreB += 1
        } 

        return scoreB - scoreA;

        // if (scoreA > scoreB) {
        //       return 1;
        // }
        // if (scoreB < scoreA) {
        //     return -1;
        // }
        // return 0;
      });  
  }

  @Watch("search")
  onSearchChanged(val: string, oldVal: string) {
    // console.log("onSearchChanged:", "val:", val, "oldVal:", oldVal);
    if (this.placeSelectedFlag){
      // console.log("PlacePicker:", "place search is disabled, place was just selected");
      this.placeSelectedFlag = false;
      return;
    }

    if (this.allowedPlacesInfo !== null && !this.allowedPlacesInfo.allowFreeAddresses) {
      // console.log("PP: use free addresses: " + this.allowedPlacesInfo.allowFreeAddresses);
      // console.log("PP addresses: " + this.allowedPlacesInfo.addresses.length);
      this.items = this.allowedPlacesInfo.addresses;
      // console.log("items addresses " + this.items.length);
      this.isLoading = false;
    } else {
    
      // console.log("PP no allowd places info found! -> free search");
    
      if (this.allowedPlacesInfo !== null) {
        this.items = this.favoritePlaces;
      }
      
      this.isLoading = val ? true : false;
      this.getGooglePlacesPredictions(
        val,
        this.autocompleteSessionToken,
        this.onPlacesResultsAvailable,
      );
    }
  }

  @Watch("allowedPlacesInfo")
  onPlacesChanged(val: IBookingAddressViewModel, oldVal: IBookingAddressViewModel) {
    // console.log("PP props allowed places changed! ");
    if (val !== null) {
      // console.log("PP allowed places size:" + val.addresses.length);
      this.allowedPlacesInfo = val;
      this.items = val.addresses;
    }
  }

  onPlacesResultsAvailable(predictions: any, status: any) {
    // console.log("places results available!");
    this.isLoading = false;
    this.items = this.concatGooglePlacesPredictions(
      this.favoritePlaces,
      predictions,
      status
    );
  }

  @Watch("model")
  onModelChanged(val: IGooglePlaceCachedPrediction, oldVal: IGooglePlaceCachedPrediction | null) {
    // console.log("onModelChanged:", "val:", val, "oldVal:", oldVal);
    this.placeSelectedFlag = true;
    if (val.result){
      this.onGetDetailsComplete(val.result, google.maps.places.PlacesServiceStatus.OK);
      return;
    }
    this.getGooglePlacesPlaceDetails(
      val.prediction,
      this.autocompleteSessionToken,
      this.onGetDetailsComplete
    );
  }

  onGetDetailsComplete(result: google.maps.places.PlaceResult, status: google.maps.places.PlacesServiceStatus) {
     // console.log("onGetDetailsComplete", "result:", result);
     // console.log("Json results:");
     // console.log(JSON.stringify({ result: result }));
    const place = this.googlePlacesApiResultToAddressViewModel(
      result,
      status,
      this.isOrigin ? AddressTypeEnum.Origin : AddressTypeEnum.Destination
    );
    if (place) {
      if (this.isOrigin) {
        this.booking.fromPlace = place;
        this.booking.fromAddress = place.address;
      } else {
        this.booking.toPlace = place;
        this.booking.toAddress = place.address;
      }
    }
    // Create a new session token because the current has now been used and can't be re-used
    this.autocompleteSessionToken = this.createNewGoogleAutocompleteSessionToken();
  }

  googlePlacesAutocompleteService: google.maps.places.AutocompleteService;
  googlePlacesService: google.maps.places.PlacesService;

  timeout(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  async mounted(){
    if (this.isOrigin){
        (window as any).__ppicker = this;
    }
  }

  getFavoritePlaceAsJson(item: IGooglePlaceCachedPrediction){
    // console.log(JSON.stringify(item));
  }

  // Usage in Chrome console: __ppicker.getPredictionResultsAsJson(items: IGooglePlaceCachedPrediction)
  getPredictionResultsAsJson(item: IGooglePlaceCachedPrediction){
      this.getPredictionResultAsJsonAsync(item);
  }

  async getPredictionResultAsJsonAsync(item: IGooglePlaceCachedPrediction){
    this.ensureGooglePlacesServicesCreated();
    await this.timeout(2000);
    
    this.getGooglePlacesPlaceDetails(
      item.prediction, 
      this.createNewGoogleAutocompleteSessionToken(), 
      (result, status) => {
        // const fav = items.find(p => p.prediction.place_id === result.place_id);
        item.result = result;
        // console.log("getPredictionResultAsJsonAsync done. Json results:");
        // console.log(JSON.stringify(item));
      }
    );
    
  }

  ensureGooglePlacesServicesCreated() {
    if (!this.autocompleteSessionToken) {
      this.autocompleteSessionToken = this.createNewGoogleAutocompleteSessionToken();
    }
    if (!this.googlePlacesAutocompleteService) {
      this.googlePlacesAutocompleteService = new (window as any)
        .google.maps.places.AutocompleteService() as google.maps.places.AutocompleteService;
    }
    if (!this.googlePlacesService) {
      this.googlePlacesService = new (window as any).google.maps.places.PlacesService(
        this.$refs.googlePlacesContainer
      ) as google.maps.places.PlacesService;
    }
  }

  createNewGoogleAutocompleteSessionToken(): google.maps.places.AutocompleteSessionToken {
    return new (window as any).google.maps.places.AutocompleteSessionToken();
  }

  getGooglePlacesPredictionsTimeout: number = 0;

  getGooglePlacesPredictions(
    search: string,
    sessionToken: google.maps.places.AutocompleteSessionToken,
    callback: (
      result: google.maps.places.AutocompletePrediction[], 
      status: google.maps.places.PlacesServiceStatus) => void
    ) {
    if (search) {
      this.ensureGooglePlacesServicesCreated();
      if (this.getGooglePlacesPredictionsTimeout) {
        window.clearTimeout(this.getGooglePlacesPredictionsTimeout);
      }
      this.getGooglePlacesPredictionsTimeout = window.setTimeout(() => {
        const request: google.maps.places.AutocompletionRequest = {
          input: search,
          componentRestrictions: {
            country: this.countryRestriction
          },
          sessionToken
        };
        this.googlePlacesAutocompleteService.getPlacePredictions(
          request,
          callback
        );
      }, 600);
    }
  }

  concatGooglePlacesPredictions(
    items: IGooglePlaceCachedPrediction[],
    predictions: google.maps.places.AutocompletePrediction[],
    status: google.maps.places.PlacesServiceStatus
  ): IGooglePlaceCachedPrediction[] {
    if (status !== google.maps.places.PlacesServiceStatus.ZERO_RESULTS) {
      if (status === google.maps.places.PlacesServiceStatus.OK) {
        return items.concat( predictions.map(p => { 
          p.description = p.description.replace(/, Suomi$/, "");
          return {
             prediction: p
          } as IGooglePlaceCachedPrediction;
        }) );
      } else {
        vuetifyToast.error(
          this.$i18n.translate(
            "booking.places.autocomplete.error",
            "Error when getting place autocomplete results from Places API: { status }",
            {
              status
            }
          )
        );
        console.error("Places API error: " + status);
      }
    }
    return items;
  }

  getGooglePlacesPlaceDetails(
    prediction: google.maps.places.AutocompletePrediction,
    sessionToken: google.maps.places.AutocompleteSessionToken,
    callback: (result: google.maps.places.PlaceResult, status: google.maps.places.PlacesServiceStatus) => void
  ) {
    if (prediction) {
      this.ensureGooglePlacesServicesCreated();
      const request: google.maps.places.PlaceDetailsRequest = {
        fields: [
          "address_components",
          "formatted_address",
          "geometry.location",
          "name",
          "place_id",
          "types",
          "vicinity"
        ],
        placeId: prediction.place_id,
        sessionToken
      }

      this.googlePlacesService.getDetails(
        request,
        callback
      );
    }
  }

  googlePlacesApiResultToAddressViewModel(
    result: google.maps.places.PlaceResult,
    status: google.maps.places.PlacesServiceStatus,
    type: AddressTypeEnum
  ): IAddressViewModel {

    if (status !== google.maps.places.PlacesServiceStatus.OK) {
      alert(
        "Error: Google Places API: googlePlacesService.getDetails: " + status
      );
      return;
    }

    const addressComponents: IGooglePlaceAddressComponents = {};
    const addressComponentTypes: any = {
      street_number: "short_name",
      route: "long_name",
      locality: "long_name",
      administrative_area_level_1: "short_name",
      country: "long_name",
      postal_code: "short_name"
    };

    result.address_components.forEach(ac => {
      const addressType = ac.types[0];  
      if (addressComponentTypes[addressType]) {
        const val = ac[addressComponentTypes[addressType]];
        addressComponents[addressType] = val;
      }
    });

    const placeType: string =
      result.types && result.types.length > 0 ? result.types[0] : "address";

    let streetAddress = [addressComponents.route, addressComponents.street_number]
      .filter(x => x)
      .join(" ");

    if (!streetAddress) {
      streetAddress = addressComponents.route;
    }

    const locality = addressComponents.locality ? addressComponents.locality : result.vicinity;
    
    const combinedAddress = [result.name, result.name.endsWith(locality) ? '' : locality]
      .filter(x => x)
      .join(", ");

    const address = combinedAddress ? combinedAddress : result.formatted_address;

    if (!streetAddress) {
      streetAddress = address;
    }

    const addressViewModel: IAddressViewModel = {
      address: streetAddress,
      city: locality,
      postalcode: addressComponents.postal_code,
      location: {
        lat: typeof(result.geometry.location.lat) === 'number' 
          ? result.geometry.location.lat as unknown as number 
          : result.geometry.location.lat(),
        lng: typeof(result.geometry.location.lng) === 'number' 
          ? result.geometry.location.lng as unknown as number 
          : result.geometry.location.lng(),
      },
      type,
      category: placeType
    };

    return addressViewModel;
  }

  get routeDestinationId(): number {
    return parseInt(this.$store.state.route.params.destinationId, 10);
  }

  get destination(): Destination {
    return this.$store.state.destination.destinations.find(
      d => d.id === this.routeDestinationId
    );
  }

  get favoritePlaces(): IGooglePlaceCachedPrediction[] {
    try {
      if (
        this.destination.favoritePlacesListType
      ) {
        return require(
          './Booking/data/favoriteplaces/' + 
          this.destination.favoritePlacesListType.toLowerCase() +
          '.json'
        ) as IGooglePlaceCachedPrediction[];
      }
    } catch (e){
      console.warn("[Timit] FavoritePlaces: no favorite places json file found." + e)
    }
    return [];
  } 

  getCountryRestriction() {
    if (window.location.hostname.endsWith("co.uk")) {
      return "gb";
    }
    if (window.location.hostname.endsWith(".us")) {
      return "us";
    }
    return "fi";
  }
}
